import {
  A,
  Box,
  Text,
  Flex,
  Image,
  Devider,
  InputSearch,
  SearchContext,
  DashPlaceholder,
  PaginationPerPageSelect,
} from 'dash-ui';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useGetExternalSaleTeamByIdForDeveloperQuery } from 'gql/generated.graphql';

const ExternalSalesUsersHeader = () => {
  const theme = useTheme();
  const { id: saleTeamId = '' } = useParams();
  const { t } = useTranslation(['common', 'pages']);

  const { setSearchSlug } = useContext(SearchContext);
  const [searchValue, setSearchValue] = useState<string>('');

  const { data } = useGetExternalSaleTeamByIdForDeveloperQuery({
    variables: { saleTeamId },
    skip: !saleTeamId,
  });
  const saleTeam = data?.getExternalSaleTeamByIdForDeveloper;

  return (
    <Box>
      <Flex p={4}>
        {saleTeam?.logoFile ? (
          <Image src={saleTeam?.logoFile?.publicUrl || ''} size={80} />
        ) : (
          <DashPlaceholder size={80} />
        )}
        <Box ml={3}>
          <Text semibold xl>
            {saleTeam?.name}
          </Text>
          {saleTeam?.website ? (
            <A href={saleTeam?.website || ''} target="_blank">
              {saleTeam?.website}
            </A>
          ) : (
            <Text>{t('pages:organisationPage.websiteUnavailable')}</Text>
          )}
        </Box>
      </Flex>
      <Devider color={theme.colors.n40} />
      <Flex p={4}>
        <InputSearch
          onClear={() => {
            setSearchSlug('');
            setSearchValue('');
          }}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
            setSearchSlug(e.target.value);
          }}
          w="100%"
          placeholder={t('common:labels.search') || ''}
        />
        <PaginationPerPageSelect
          mx={3}
          maxWidth={130}
          w="100%"
          label={t('common:labels.show') || ''}
        />
      </Flex>
    </Box>
  );
};

export default ExternalSalesUsersHeader;
